import React, {useEffect, useRef, useState} from 'react';
import {DayPilot, DayPilotCalendar, DayPilotNavigator} from "@daypilot/daypilot-lite-react";
import "./Calendar.scss";
import { isTechnical, isOperation } from 'utils/helpers/check-roles';
import UseGetCalenderTickets from 'hooks/query/calender/UseGetCalenderTickets';
import i18next, { t } from 'i18next';
import { Flex, Spin } from 'antd';
import { StatusColor } from 'utils/helpers/ticket_status';
import { Ticket } from 'utils/helpers/static_data';
import { UserModel } from 'models/users';
import { UserData } from 'utils/helpers/encrypt-decrypt-user';
import useTechnicalsUsers from 'hooks/query/users/useTechnicalsUsers';
import ticket_not_found from "../../assets/images/ticket_not_found.png";



const contentStyle: React.CSSProperties = {
padding: 50,
background: 'rgba(0, 0, 0, 0.05)',
borderRadius: 4,
};
const content = <div style={contentStyle} />;
const buildDateRange = (date: DayPilot.Date) => {
    const d = new Date(date.toString());
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return {
        date: `${yyyy}-${mm}-${dd}`,
        start_date: `${yyyy}-${mm}-${dd} 00:00:00`,
        end_date: `${yyyy}-${mm}-${dd} 23:59:59`,
    };
};
const CalednerZone = () => {

    const [calenderTicketsData, setCalenderTicketsData] = useState<any>([]);
    const [technicalsColumns, setTechnicalsColumns] = useState<any>([]);
    const [User, setUser] = useState<UserModel | null>(null);
    const [todayDate, setTodayDate] = useState<any>(buildDateRange(new DayPilot.Date()).date);
    let eventsCount = null
    const dateRange = buildDateRange(todayDate);
    const { data: calenderData, isLoading, isFetching } = UseGetCalenderTickets({
        start_date: dateRange.start_date,
        end_date: dateRange.end_date,
    });
    const Users = useTechnicalsUsers({
        page: undefined,
        search: undefined,
        enabled: undefined,
    });
    const calendarRef = useRef<any>();
    const [events, setEvents] = useState<any>([]);
    const [columns, setColumns] = useState<any>([]);

    //get the data
    useEffect(() => {
        if(isTechnical(User?.role_id!)){
            setCalenderTicketsData(calenderData?.data);
        }
        else if(isOperation(User?.role_id!)){
            setTechnicalsColumns(Users?.data?.pages?.[0]?.data);
            setCalenderTicketsData(calenderData?.data);
        }
    }, [calenderData, Users]);

    //make the row (events)
    useEffect(() => {
        if (!calenderTicketsData?.length) return;
        const tickets = calenderTicketsData?.map((item:any) => item.assigned_tickets)?.flat() || [];
        const events = tickets.flatMap((ticket:any) => 
            (ticket.calender || []).map((cal:any) => ({
                text: `${t("ticket")} - ${ticket.id}`,
                start: cal.start_date,
                end: cal.end_date,
                resource: isTechnical(User?.role_id!)? ticket.id : ticket.assigned_to, // to connect the event using resource with the column
                flag: cal.flag,
                priority: ticket.priority,
                customer_name:ticket.user.full_name,
                customer_phone: ticket.user.contacts.map((contact:any) => contact.value).join(', '),
            }))
        );
        setEvents(events);
    }, [calenderTicketsData]);

    //make the column
    useEffect(() => {
        if(isTechnical(User?.role_id!)){
            if (!calenderTicketsData?.length){
                setColumns([]);
            }
            else {
                const tickets = calenderTicketsData?.map((item:any) => item.assigned_tickets)?.flat() || [];
                const columns = tickets.map((ticket:any, index:number) => ({
                    name: `${t("ticket")} ${index + 1}`,
                    id: ticket?.id || `T${index + 1}`,
                }));
                setColumns(columns);
            }
        }
        else if(isOperation(User?.role_id!)){
            if (!technicalsColumns?.length) {
                setColumns([]);
            }
            else {
                // const columns = technicalsColumns?.map((technicalId:any, index:number) => ({
                //     name: technicalId.full_name,
                //     id: technicalId.id || `T${index + 1}`,
                // }));
                // setColumns(columns);
                // const tickets =
                //     calenderTicketsData?.map((item: any) => item.assigned_tickets)?.flat() || [];
                const tickets =
                    calenderTicketsData?.map((item: any) => item)?.flat() || [];
                // console.log("tickets", tickets);
                
                // const columns = technicalsColumns.map((technical: any, index: number) => {
                //     eventsCount = tickets.reduce(
                //         (count: number, ticket: any) =>
                //             ticket.assigned_to === technical.id
                //                 ? count + (ticket.calender?.length || 0)
                //                 : count,
                //         0
                //     );
                const columns = technicalsColumns.map((technical: any, index: number) => {
                    eventsCount = tickets.reduce(
                        (count: number, ticket: any) =>
                            ticket.id === technical.id
                                ? count + (ticket.assigned_tickets?.length || 0)
                                : count,
                        0
                    );
                    return {
                        id: technical.id || `T${index + 1}`,
                        name: `${technical.full_name} (${eventsCount})`,
                        width : eventsCount > 0 ? (eventsCount * 300) + 50 : 250,
                    };
                });
                // console.log("columns", columns)
                setColumns(columns);
            }
        }
        else {
            console.log("other role");
        }
    }, [calenderTicketsData,technicalsColumns]);
    
    useEffect(() => {
    setUser(UserData.Decrypt());
    }, []);

    const next = () => {
        const newDate = new DayPilot.Date(todayDate).addDays(1);
        setTodayDate(newDate);
    };
    const previous = () => {
        const newDate = new DayPilot.Date(todayDate).addDays(-1);
        setTodayDate(newDate);
    };
    // to prevent event dragging
    const onEventMove = (args: any) => {
        args.preventDefault();
    };
    // to prevent event resizing
    const onEventResize = (args: any) => {
        args.preventDefault();
    };
    // style of the event
    const onBeforeEventRender = (args: any) => {
        const backColor = 
            args.data.flag === "assigned" 
            ? 
                StatusColor(Number(Ticket.assigned))
            : 
                args.data.flag === "active" 
                    ? 
                        StatusColor(Number(Ticket.active))
                    :   StatusColor(Number(Ticket.ticket_paused));
        args.data.fontColor = "#ffffff";
        args.data.backColor = backColor + "77";
        args.data.borderColor = "darker";
        args.data.html = `
            <div
                style="padding: 7px; color: black; background-color: rgba(255,255,255,0.7); border-radius: 4px; margin-top: 70px;"
            >
                <p style="font-size: 12px;">${t("customer_name")}: ${t(args.data.customer_name)}</p>
                <p style="font-size: 12px;">${t("customer_phone")}: ${t(args.data.customer_phone)}</p>
                <p style="font-size: 12px;">${t("start_ticket")}: ${i18next.language === "en" ? args.data.start.toString("yyyy-MM-dd HH:mm") : args.data.start.toString("dd-MM-yyyy HH:mm")}</p>
                <p style="font-size: 12px;">${t("end_ticket")}: ${i18next.language === "en" ? args.data.end.toString("yyyy-MM-dd HH:mm") : args.data.end.toString("dd-MM-yyyy HH:mm")}</p>
                <p style="${args.data.priority === 0 ? "" : "color: red"}">${t("priority")}: ${t(args.data.priority === 0 ? t("normal") : t("emergent"))}</p>
                <p style="font-size: 12px;">${t("status")}: ${t(args.data.flag)}</p>
            </div>
        `;
        args.data.areas = [
        {
            left: 4,
            top: 4,
            right: 4,
            height: 26,
            text: args.data.text,
            padding: 2,
            backColor: backColor + "cc",
            fontColor: "#ffffff",
            verticalAlignment: "center",
            horizontalAlignment: "center",
            borderRadius: 4,
        },
        ];
    };

    //this useEffect is just for to make the columns(technical) width take it from the column object
    useEffect(() => {
        const container = document.querySelector(
            ".calender-operation"
        );

        if (!container) return;

        const applyWidths = () => {
        const tables = container.querySelectorAll(
            "table"
        ) as NodeListOf<HTMLTableElement>;

        // console.log("tables", tables);
        tables.forEach((table, index1) => {
                // console.log("table","index", index1, table);

            const rows = table.querySelectorAll("tr");
            // console.log("rows",rows);

            rows.forEach(row => {
                // console.log("row", row);

                const cells = Array.from(
                    row.querySelectorAll("td, th")
                ) as HTMLElement[];
                // console.log("cells", cells)

                cells.forEach((cell, index2) => {
                    const width = columns[index2]?.width;
                    if (width) {
                        cell.style.setProperty(
                            "width",
                            `${width}px`,
                            "important"
                        );
                    }
                });
            });
            });
        };


        applyWidths();

        const observer = new MutationObserver(() => {
            applyWidths();
        });

        observer.observe(container, {
            childList: true,
            subtree: true,
            // attributes: true,
            // attributeFilter: ["style", "class"]
        });


        return () => {
            observer.disconnect();
        };

    }, [columns]);

  return (
    <>
            {
            isLoading || isFetching
            ? 
            <Flex style={{justifyContent: "center", alignItems: "center"}}  gap="middle" vertical>
                <Spin size="large">
                    {content}
                </Spin>
            </Flex>
            : 
                <div className={"wrap"}>
                    {/* design of the calender */}
                    <div className={"left"}>
                        <DayPilotNavigator
                            selectMode={"Day"}
                            showMonths={3}
                            skipMonths={3}
                            selectionDay={todayDate}
                            startDate={todayDate}
                            onTimeRangeSelected={ args => setTodayDate(args.day) }
                        />
                    </div>
                    <div className={"calendar"}>
                        {/* change the date */}
                        <div className={"toolbar"}>
                            {/* <ResourceGroups onChange={(args: any) => setSelected(args.selected)} items={groups}></ResourceGroups> */}
                            <span>{t("day")}:</span>
                            <button style={{padding: "10px 10px", width: "fit-content"}} onClick={() => previous()}>{t("previous_day")}</button>
                            <button style={{padding: "10px 10px", width: "fit-content"}} onClick={() => next()}>{t("next_day")}</button>
                        </div>

                        {columns.length !== 0 
                        ?
                        <>
                            {/* design of the custome calender */}
                            <div className={`${isTechnical(User?.role_id!) ? "calender-technical" : "calender-operation"}`}>
                                <DayPilotCalendar
                                    viewType={"Resources"}
                                    headerHeight={40}
                                    eventBorderRadius={6}
                                    durationBarVisible={false}
                                    // onTimeRangeSelected={onTimeRangeSelected}
                                    // onEventClick={onEventClick}
                                    // onBeforeHeaderRender={onBeforeHeaderRender}

                                    //the style for the ticket
                                    onBeforeEventRender={onBeforeEventRender}
                                    onEventMove={onEventMove}
                                    onEventResize={onEventResize}
                                    startDate={todayDate}
                                    events={events}
                                    columns={columns}
                                    ref={calendarRef}
                                />
                            </div>
                        </>
                        : 
                        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%"}}>
                            <img style={{width: "250px"}} src={ticket_not_found} alt='no_photo'/>
                            <p>{t("no_ticket_found_in_this_day")}</p>
                        </div>
                        }
                    </div>
                </div>
            }
    </>
  );
}

export default CalednerZone